import { render } from "./CandidateProfile.vue?vue&type=template&id=ddbe0f88&scoped=true"
import script from "./CandidateProfile.vue?vue&type=script&lang=js"
export * from "./CandidateProfile.vue?vue&type=script&lang=js"

import "./CandidateProfile.vue?vue&type=style&index=0&id=ddbe0f88&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbe0f88"]])

export default __exports__